import React from 'react';

import type { FC } from 'react';

export const Delete: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <path d="M4.00001 12.6667C4.00001 13.4 4.60001 14 5.33334 14H10.6667C11.4 14 12 13.4 12 12.6667V6C12 5.26667 11.4 4.66667 10.6667 4.66667H5.33334C4.60001 4.66667 4.00001 5.26667 4.00001 6V12.6667ZM12 2.66667H10.3333L9.86001 2.19333C9.74001 2.07333 9.56668 2 9.39334 2H6.60668C6.43334 2 6.26001 2.07333 6.14001 2.19333L5.66668 2.66667H4.00001C3.63334 2.66667 3.33334 2.96667 3.33334 3.33333C3.33334 3.7 3.63334 4 4.00001 4H12C12.3667 4 12.6667 3.7 12.6667 3.33333C12.6667 2.96667 12.3667 2.66667 12 2.66667Z" />
    </svg>
  );
};
